import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as estimateActions from '../../actions/estimateActions';
import * as utils from '../../utils';
import Grid from './Grid';
import Slide from './Slide';
import Introduction from './Introduction';
import Scroll from 'react-scroll';
import Collapsed from '../common/Collapsed';
import { default as config } from '../../constants';

/**
 * What's going on here???? Why is this so complicated?
 * Glad you asked... There are not hard facts or shortcuts
 * that we can take when building out a budget step. Re
 * we need to plan on a budget step having any number of
 * sliders or input grids. We need sliders and
 * grids to work together in some ways but when a slider
 * follows a grid we need them to act as a multiplier.
 * And so that leads us to our array of budget items
 * with each item in the array corresponding to a single
 * item in the step group. Remember that the step groups
 * are loaded from the wordpress rest API, or if caches
 * are enabled in constants.js then we use local storeage
 */
class StepContainer extends Component {
  constructor(props, context) {
		super(props, context);
		let budgetItems = []
		for(let i = 0; i < props.group.items.length; i++) {
			// Here be the logic for removing the add button when
			// there is only a single item in the grid... arrrr....
			if(props.group.items[i].grid !== undefined
			&& props.group.items[i].grid.length === 1) {
				budgetItems.push(Object.assign({}, {selectedValue: null,
					selectedValues: [],
					selectedSliderIndex: null,
					visited: false,
					selectedGridIndex: 0}));
			} else {
				budgetItems.push(Object.assign({}, {selectedValue: null,
					selectedValues: [],
					selectedSliderIndex: null,
					visited: false,
					selectedGridIndex: null}));
			}
		}
		this.state = {budgetItems: budgetItems};
		this.domRef = React.createRef();
		this.sliderSelectionHandler = this.sliderSelectionHandler.bind(this);
		this.gridSelectionHandler = this.gridSelectionHandler.bind(this);
		this.valueHandler = this.valueHandler.bind(this);
		this.incrementHandler = this.incrementHandler.bind(this);
		this.decrementHandler = this.decrementHandler.bind(this);
		this.openClickHandler = this.openClickHandler.bind(this);
		this.openNextItemAndSetVisited = this.openNextItemAndSetVisited.bind(this);
	}

	validate(user) {
		return {
		}
	}



	sliderSelectionHandler(value, positionIndex) {
		let st = [...this.state.budgetItems];
		st[positionIndex].selectedSliderIndex = value;
		this.props.actions.saveValues(this.props.id, st);
		this.setState({budgetItems: st});
	}

	visitedMarker() {
		return (
			<svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" /></svg>
		)
	}

	selectionNotification() {
		let nstring = 'Visited';
		return (
			<small>
				{nstring}
			</small>
		)
	}

	gridSelectionHandler(value, positionIndex, item) {
		let st = [...this.state.budgetItems];
		if(st[positionIndex].selectedValues[value] === undefined) {
			st[positionIndex].selectedValues[value] = 0;
		}
		st[positionIndex].selectedGridIndex = Number(value);
		this.setState({budgetItems: st});
	}

	valueHandler(val, positionIndex, itemIndex) {
		let st = [...this.state.budgetItems];

		st[positionIndex].selectedValues[itemIndex] = Number(val);
		this.props.actions.saveValues(this.props.id, st);
		this.setState({budgetItems: st});
	}

	incrementHandler(positionIndex, itemIndex) {
		let st = [...this.state.budgetItems];

		if(st[positionIndex].selectedValues[itemIndex] === undefined)
			st[positionIndex].selectedValues[itemIndex] = 1;
		else
			st[positionIndex].selectedValues[itemIndex] += 1;
		this.setState({budgetItems: st});
		this.props.actions.saveValues(this.props.id, st);
		return false;
	}

	decrementHandler(positionIndex, itemIndex) {

		let st = [...this.state.budgetItems];

		if(st[positionIndex].selectedValues[itemIndex] === undefined)
			st[positionIndex].selectedValues[itemIndex] = 0;
    else if (st[positionIndex].selectedValues[itemIndex] === 0)
      st[positionIndex].selectedValues[itemIndex] = 0;
    else
			st[positionIndex].selectedValues[itemIndex] -= 1;
		this.setState({budgetItems: st});
		this.props.actions.saveValues(this.props.id, st);
		return false;
	}

	componentDidUpdate(oldProps, oldState) {
		if(oldProps.open === false && this.props.open === true) {
			Scroll.animateScroll.scrollTo(utils.getOffset(this.domRef.current).top-120)
		}

		if(oldProps.mandatories.currentLine !== this.props.mandatories.currentLine) {
			// We are change items so we update the state with the estimate:
			if(this.props.estimates[this.props.mandatories.currentLine] !== undefined) {
				//this.setState({budgetItems: [...this.props.estimates[this.props.id]]});
				//console.log("called map");
			}
		}
	}

	contentWhenOpen(toggleStep, group, positionInGlobalEstimateArray) {
		return (
			<div className="content">
				{group.items.length && group.items.map((item, index, otherItems) =>{
					if(otherItems[index-1] !== undefined
					&& otherItems[index-1].item_type === 'fieldGrid'
					&& item.item_type === 'slider' ) {
						return
					} else if(otherItems[index+1] !== undefined
						&& otherItems[index+1].item_type === 'slider'
						&& item.item_type === 'fieldGrid'
						&& otherItems.length > 2) {
						return (
							<Collapsed key={index} title={item.item_title}>
								<Grid
									key={index}
									fields={item.grid}
									statePosition={index}
									selectedIndex={this.state.budgetItems[index].selectedGridIndex}
									// Why do we devote so many lines to popluating the array of valus?
									// The answer is that we have a lot of undefined checking to do. We
									// need to account for the fact that estimates can be partially complete
									// for each budgetItem. This leads us to lots of checking, as we cannot
									// count on data being in any particular spot for any applicaiton state
									values={this.props.estimates[positionInGlobalEstimateArray] === undefined
										? this.state.budgetItems[index].selectedValues
											: this.props.estimates[positionInGlobalEstimateArray][index] === undefined
												? this.state.budgetItems[index].selectedValues
												: this.props.estimates[positionInGlobalEstimateArray][index].selectedValues}
									selectionHandler={this.gridSelectionHandler}
									valueHandler={this.valueHandler}
									incrementHandler={this.incrementHandler}
									decrementHandler={this.decrementHandler}
									/>
								<Slide
									key={index+1}
									statePosition={index+1}
									stops={otherItems[index+1].slider.stops}
									selectionHandler={this.sliderSelectionHandler}
									selectedIndex={this.props.estimates[positionInGlobalEstimateArray] === undefined
                    ? this.state.budgetItems[index+1].selectedSliderIndex
                    : this.props.estimates[positionInGlobalEstimateArray][index+1] === undefined
										  ? this.state.budgetItems[index+1].selectedSliderIndex
										  : this.props.estimates[positionInGlobalEstimateArray][index+1].selectedSliderIndex}
									title={otherItems[index+1].item_title}  />
							</Collapsed>
						)
					}
          
					else {
						switch (item.item_type) {
							case "slider":
								// To make the back button work and refresh
								// pass in the estimate value from local storage
								const sliderIndex = this.props.estimates[positionInGlobalEstimateArray] === undefined ? 1
								: this.props.estimates[positionInGlobalEstimateArray][index].selectedSliderIndex;
								return (<Slide
									key={index}
									statePosition={index}
									stops={item.slider.stops}
									selectionHandler={this.sliderSelectionHandler}
									selectedIndex={sliderIndex}
									title={item.item_title}  />);
							case "fieldGrid" :
								return (<Grid
									key={index}
									fields={item.grid}
									statePosition={index}
									selectedIndex={this.state.budgetItems[index].selectedGridIndex}
									values={this.props.estimates[positionInGlobalEstimateArray] === undefined
										? this.state.budgetItems[index].selectedValues
											: this.props.estimates[positionInGlobalEstimateArray][index] === undefined
												? this.state.budgetItems[index].selectedValues
												: this.props.estimates[positionInGlobalEstimateArray][index].selectedValues}
									selectionHandler={this.gridSelectionHandler}
									valueHandler={this.valueHandler}
									incrementHandler={this.incrementHandler}
									decrementHandler={this.decrementHandler}
									/>);
							default :
								return (<Introduction key={index} />);
						}
					}
				})}
				{this.props.displayNextButton && <button type="button" className="btn large" onClick={toggleStep}>Next</button>}
			</div>
		)
	}
	openClickHandler() {
		this.props.openItem(this.props.id);
	}

	openNextItemAndSetVisited() {
		this.setState({visited: true})
		this.props.nextItem();
	}

	render() {
		const { id, group, open } = this.props; // Destructure this.props to make coding a bit less error prone.
		return (
			<section className="calculator-step" name={id} ref={this.domRef}>
				<h4 onClick={this.openClickHandler}>
				{this.props.estimates[id] !== undefined && this.visitedMarker()}
				{group.items[0].item_title}
				{open === true
					? <a className="calculator-step-toggle-close">-</a>
					: <a className="calculator-step-toggle-open">+</a>}
				{this.props.estimates[id] !== undefined && this.selectionNotification()}
				</h4>
				{open && this.contentWhenOpen(this.openNextItemAndSetVisited, group, id)}


			</section>
		);
	}
}

StepContainer.propTypes = {
	open: PropTypes.bool.isRequired,
	actions: PropTypes.object,
	openItem: PropTypes.func.isRequired,
	nextItem: PropTypes.func.isRequired,
	group: PropTypes.object.isRequired,
	id: PropTypes.string.isRequired,
	displayNextButton: PropTypes.bool.isRequired
}


const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: bindActionCreators(estimateActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {

	// let mostFavoriteIds = state.user.FavoriteLocations.filter(loc => loc.IsMostFavorite).map(mostFav => mostFav.RestaurantId);
	// let immutableRestaurants = [...state.restaurants].map((restaurant) => {
	// 	return Object.assign({}, restaurant, { IsMostFavorite: mostFavoriteIds.indexOf(restaurant.Id) > -1 });
	// });

	// immutableRestaurants.sort((rA, rB) => {
	// 	let nameA = rA.Title.toUpperCase(); // ignore upper and lowercase
	// 	let nameB = rB.Title.toUpperCase(); // ignore upper and lowercase
	// 	if (rA.IsMostFavorite ^ rB.IsMostFavorite) {
	// 		return rA.IsMostFavorite ? -1 : 1; // mostFavoriteRestaurant should be closer to the beginning of the list
	// 	} else {
	// 		if (nameA < nameB) return -1;
	// 		if (nameA > nameB) return 1;
	// 		return 0;
	// 	}
	// });

	return {
		mandatories: state.mandatories,
		estimates: state.estimates
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(StepContainer);



// WEBPACK FOOTER //
// ./src/components/step/StepContainer.js